import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {UserDetailsModel} from '../../../../constants/userModel';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../shared/error-page/service/error-service';
import {Constants} from '../../../../constants/ebtq-constants';
import {EBTransactionAbstract} from '../../../../model/eBTransactionAbstract';
import {TransactionWrapper} from '../../../../model/transactionWrapper';
import {Router} from '@angular/router';
import {UtilityService} from '../../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-paymentChange',
  templateUrl: './paymentChange.component.html',
  styleUrls: ['./paymentChange.component.scss']
})
export class paymentChangeComponent implements OnInit {
  reasonForChange: any[];
  reason: string = null;
  successMess: boolean;
  loanNumber: string;
  effDate: string;
  containsError = false;
  errorMsg: string;
  payoffAmount: string = null;
  showErrorDiv = false;
  errHeading: string;
  errorMessage: any[];
  userDetails: UserDetailsModel;
  transAmount: number = null;
  mainPage: string;
  actionCode: any[];
  actionCodeType: string;
  paymentPlans: any[];
  paymentPlan: string;
  utilService: UtilityService;
  lineOfCredit = '';
  ScheduledPayment: string = null;
  loanTerm: string = null;
  percentage: string = null;
  fromEMBRequiredControl: string = null;
  toEMBRequiredControl: string = null;
  displayLoanNumber: string;
  displayEffDate: string;
  displayPaymentPlan: string;
  displayWarningMsg: any[];
  currentProcessingDate: string;
  title = 'Payment Change';
  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private router: Router, private routerCore: Router, private titleService: Title, private cdr: ChangeDetectorRef) {

    this.mainPage = 'transactions';
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.utilService = new UtilityService();
    this.successMess = false;
    this.errHeading = Constants.ERROR_HEADER;
    this.errorMessage = [];
    this.userDetails = Constants.USER_DETAILS;
    this.actionCode = [];
    this.actionCode.push({label: '80-Part Prepymt/Reduce UPB Only', value: '80'});
    this.actionCode.push({label: '81-Part Prepymt/Increase Net LOC', value: '81'});
    this.actionCode.push({label: '82-Part Prepymt/Inc Repair Set-Aside', value: '82'});
    this.actionCode.push({label: '83-Part Prepymt/Increase Taxes&Inc', value: '83'});
    this.actionCode.push({label: '84-Part Prepymt/Inc 1st Yr Prop Chgs', value: '84'});
    this.actionCodeType = '80';

    this.paymentPlans = [];
    this.paymentPlans.push({label: 'Term', value: '1'});
    this.paymentPlans.push({label: 'Tenure', value: '2'});
    this.paymentPlans.push({label: 'Modified Term', value: '3'});
    this.paymentPlans.push({label: 'Modified Tenure', value: '4'});
    this.paymentPlans.push({label: 'Line of Credit', value: '5'});
    this.paymentPlan = '1';

    this.reasonForChange = [];
    this.reasonForChange.push({label: 'Access Growth for Taxes & Insurance', value: '1'});
    this.reasonForChange.push({label: 'Access Growth for Repairs', value: '2'});
    this.reasonForChange.push({label: 'Access Growth for Purchase Adjustment', value: '3'});
    this.reasonForChange.push({label: 'Borrower\'s Request', value: '4'});
    this.reason = '1';

    this.apiService.getCurrentProcessingDate().subscribe(
      (data: any) => {
        this.currentProcessingDate = this.utilService.convertMillisecToDate(data.date);
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
        console.log('error:' + error);
      }
    );
  }

  clearBtn() {
    this.successMess = false;
    this.effDate = null;
    this.loanNumber = '';
    this.transAmount = null;
    this.paymentPlan = '1';
    this.reason = '1';
    this.actionCodeType = '80';
    this.lineOfCredit = '';
    this.ScheduledPayment = '';
    this.loanTerm = '';
    this.percentage = '';
    this.fromEMBRequiredControl = '';
    this.toEMBRequiredControl = '';

  }

  paymentChangeComponent() {
    this.errorMessage = [];
    if (this.validate()) {
      const ebTransactionAbstract = new EBTransactionAbstract();
      ebTransactionAbstract.effectiveDate = this.effDate;
      ebTransactionAbstract.lastUpdatedUserId = sessionStorage.getItem('userID');
      ebTransactionAbstract.fannieMaeLoanNumber = this.loanNumber;
      ebTransactionAbstract.appCode = this.actionCodeType;
      ebTransactionAbstract.transactionAmount = this.transAmount;
      ebTransactionAbstract.recordCreatorUserID = sessionStorage.getItem('userID');



      this.getServiceNumber(ebTransactionAbstract);
    }
  }

  /** Navigate to Loan detailed page */
  public loanDetail() {
    if (this.loanValidate()) {
      const transactionWrapper = new TransactionWrapper();
      transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
      transactionWrapper.parameters[0] = this.loanNumber;
      transactionWrapper.effDate = this.effDate;
      transactionWrapper.appCode = this.actionCodeType;
      this.apiService.executeQuery(transactionWrapper)
        .subscribe(
          (data: any) => {
            if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
              this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
            } else {
              const srvrNo = data.object[0].SRVR_NO;
              if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
                this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
              } else {
                this.router.navigate(['queryLoansDetails'], {
                  queryParams: {
                    loanNumber: this.loanNumber,
                    mainPage: this.mainPage,
                    subPage:'paymentChange'
                  }
                });
              }
            }
          });
    }
  }

  loanValidate() {
    this.errorMessage = [];
    this.successMess = false;
    let valid = true;
    if (this.loanNumber === undefined || this.loanNumber === '' || this.loanNumber.length !== 10 || !/^[0-9]+$/.test(this.loanNumber) || !this.loanNumber.startsWith('6')) {
      valid = false;
      this.errorMessage.push(Constants.LOAN_NUM_ERR_COUNT);
    }
    return valid;
  }


  dateToStringConversion(dateVal)
  {
    const date = this.utilService.convertDateToMillisec(dateVal);
    return this.utilService.convertMillisecToDate(date);

  }

  validate() {
    this.errorMessage = [];
    this.successMess = false;
    let valid = true;

    if (this.effDate != null && this.effDate !== undefined) {
      const dateString = this.dateToStringConversion(this.effDate);
      this.effDate = dateString;
    }

    if (this.fromEMBRequiredControl != null && this.fromEMBRequiredControl !== undefined) {
      const dateString = this.dateToStringConversion(this.fromEMBRequiredControl);
      this.fromEMBRequiredControl = dateString;
    }

    if (this.toEMBRequiredControl != null && this.toEMBRequiredControl !== undefined) {
      const dateString = this.dateToStringConversion(this.toEMBRequiredControl);
      this.toEMBRequiredControl = dateString;
    }

    if (this.loanNumber === undefined || this.loanNumber === '' || this.loanNumber.length !== 10 || !/^[0-9]+$/.test(this.loanNumber)) {
      valid = false;
      this.errorMessage.push(Constants.LOAN_NUM_ERR_COUNT);
    }

    if (this.effDate === undefined || this.effDate === '' || this.effDate == null) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_EMPTY);
    } else if (!this.validateDateFormat(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDate(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDateYear(this.effDate)) {
      valid = false;
    }

    if (this.lineOfCredit !== undefined && this.lineOfCredit !== '') {
      const flag = this.validAmount(this.lineOfCredit);
      if (!flag)
      {
        valid = false;
        this.errorMessage.push(Constants.LINE_OF_CREDIT_FORMAT);
      }
    }

    if (this.ScheduledPayment !== undefined && this.ScheduledPayment !== '') {
      const flag = this.validAmount(this.ScheduledPayment);
      if (!flag)
      {
        valid = false;
        this.errorMessage.push(Constants.SCHEDULED_PAYMENT_FORMAT);
      }
    }

    if (this.transAmount !== undefined && String(this.transAmount) !== '') {
      const flag = this.validAmount(String(this.transAmount));
      if (!flag)
      {
        valid = false;
        this.errorMessage.push(Constants.TRANSACTION_ASIDE_AMNT_FORMAT);
      }
    }

    if (this.loanTerm !== undefined && this.loanTerm !== '') {
      if (isNaN(Number(this.loanTerm)))
      {
        valid = false;
        this.errorMessage.push(Constants.REMAING_TERM_GREATRE_ZERO);
      }
      else if (Number(this.loanTerm) < 1 || Number(this.loanTerm) === 0) {
        valid = false;
        this.errorMessage.push(Constants.REMAING_TERM_GREATRE_ZERO);
      }
    }
    if (this.percentage !== undefined && this.percentage !== '') {
      const flag = this.validAmount(this.percentage);
      if (!flag) {
        valid = false;
        this.errorMessage.push(Constants.TRANS_ASIDE_PERCENT_VALID);
      }
    }
    if (this.fromEMBRequiredControl !== undefined && this.fromEMBRequiredControl !== '') {
      if (!this.validateDateFormat(this.fromEMBRequiredControl)) {
        valid = false;
        this.errorMessage.push(Constants.TAXES_AMNT_BEGIN_DATE_VALID);
      } else if (!this.isValidDate(this.fromEMBRequiredControl)) {
        valid = false;
        this.errorMessage.push(Constants.TAXES_AMNT_BEGIN_DATE_VALID);
      } else if (!this.isValidDateYear(this.fromEMBRequiredControl)) {
        valid = false;
      }
    }

    if (this.toEMBRequiredControl !== undefined && this.toEMBRequiredControl !== null && this.toEMBRequiredControl !== '') {
      if (!this.validateDateFormat(this.toEMBRequiredControl)) {
        valid = false;
        this.errorMessage.push(Constants.TAXES_AMNT_END_DATE_VALID);
      } else if (!this.isValidDate(this.toEMBRequiredControl)) {
        valid = false;
        this.errorMessage.push(Constants.TAXES_AMNT_END_DATE_VALID);
      } else if (!this.isValidDateYear(this.toEMBRequiredControl)) {
        valid = false;
      }
    }

    if (this.paymentPlan !== undefined && this.paymentPlan !== '') {
      const flag = this.utilService.isContainIllegalChar(this.paymentPlan);
      if (flag) {
        valid = false;
        this.errorMessage.push(Constants.PAYMENT_PLAN_INVALID);
      }
    }
    if (this.reason !== undefined && this.reason !== '') {
      const flag = this.utilService.isContainIllegalChar(this.reason);
      if (flag) {
        valid = false;
        this.errorMessage.push(Constants.PAYMENT_REASON_CHANGE_INVALID);
      }
    }


    /*
    if (this.transAmount === undefined || this.transAmount === null  ) {
      valid = false;
      this.errorMessage.push(Constants.LOAN_AMT_EMPTY_MESSAGE);
    }else if (this.transAmount < 0 || this.transAmount == 0){
      valid = false;
      this.errorMessage.push(Constants.GREATER_HTAN_ZERO);
    }*/
    return valid;
  }

  validAmount(amount) {

    //let pattern= /^[\\+\\-]?([0-9]*[\\.][0-9][0-9]?|[0-9]*)/;
    if (isNaN(amount))
    {
      return false;
    }
    else {
      const index = amount.indexOf('.');
      if (index === -1)
      {
        amount = amount + '.00';
      }
      else {
        const decimal = amount.substring(index + 1);
        if (decimal.length > 2)
        {
          return false;
        }
      }
      const pattern = /^[-+]?[0-9]+\.[0-9]+$/;
      return pattern.test(amount);
    }


  }

  validDecimalPercent(decimalPercent)
  {
    const pattern = /^\s*[\+\-]?[0-9]*[\.][0-9]+\s*|\s*[\+\-]?[0-9]+\s*/;
    return pattern.test(decimalPercent);
  }


  validateDateFormat(dateStr: string) {
    if (dateStr === undefined || dateStr.trim() === '' || dateStr.length !== 10) {
      return false;
    }
    return true;
  }

  isValidDate(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }


  isValidDateYear(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
    {return false;}
    const currentTime = new Date();
    // Parse the date parts to integers
    const parts = dateString.split('/');
    const year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1600) {
      this.errorMessage.push(Constants.PLS_RE_SUBMIT);
      return false;
    }
    return true;
  }

  showloanDetailWrappers() {
    if (this.loanValidate()) {
      const transactionWrapper = new TransactionWrapper();
      transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
      transactionWrapper.parameters[0] = this.loanNumber;
      transactionWrapper.effDate = this.effDate;
      transactionWrapper.appCode = this.actionCodeType;
      this.apiService.executeQuery(transactionWrapper)
        .subscribe(
          (data: any) => {
            if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
              this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
            } else {
              const srvrNo = data.object[0].SRVR_NO;
              if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
                this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
              } else {
                this.routerCore.navigate(['queryTransactions'], {
                  queryParams: {
                    loanNumber: this.loanNumber,
                    mainPage: this.mainPage,
                    fromPerformTrans: true,
                    subPage:'paymentChange'
                  }
                });
              }
            }
          });
    }
  }

  getServiceNumber(ebTransactionAbstract: EBTransactionAbstract) {

    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters[0] = this.loanNumber;
    transactionWrapper.effDate = this.effDate;
    transactionWrapper.appCode = this.actionCodeType;

    this.apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
            this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
              this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
            } else {
              ebTransactionAbstract.servicerNumber = '' + data.object[0].SRVR_NO;
              this.executePaymentChangeTransaction(ebTransactionAbstract);
            }
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        console.log('Error message *** ' + message);
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }


  executePaymentChangeTransaction(ebTransactionAbstract: EBTransactionAbstract) {
    const transactionWrapper = new TransactionWrapper();


    let transactionType: number;
    let effDate: string;
    effDate = this.utilService.convertMillisecToDate(this.effDate);

    if (effDate > this.currentProcessingDate) {
      transactionType = 1;
    } else {
      transactionType = 2;
    }

    const paymentChangeObj = {

      recordCreatorUserID: sessionStorage.getItem('userID'),
      remainingTerm:this.loanTerm,
      paymentPlanTypeCode : {code:Number(this.paymentPlan)},
      effectiveDate: {date:this.utilService.convertDateToMillisec(this.effDate)},
      servicerNumber: ebTransactionAbstract.servicerNumber,
      fannieMaeLoanNumber: this.loanNumber,
      lastUpdatedUserId: sessionStorage.getItem('userID'),
      transactionType : {code: transactionType }
    };

    if (this.lineOfCredit != null && this.lineOfCredit.length > 0) {
      paymentChangeObj['lineOfCreditReserve'] = {value:this.lineOfCredit};
    }

    if (this.ScheduledPayment != null && this.ScheduledPayment.length > 0) {
      paymentChangeObj['scheduledPaymentAmount'] = {value:this.ScheduledPayment};
    }

    if (this.transAmount != null && String(this.transAmount).length > 0) {
      paymentChangeObj['taxesAndInsuranceSetAsideAmount'] = {value:this.transAmount};
    }

    if (this.percentage != null && this.percentage.length > 0) {
      paymentChangeObj['taxesAndInsuranceSetAsidePercent'] = {amount: Number(this.percentage) / 10000};
    }

    if (this.fromEMBRequiredControl != null && this.fromEMBRequiredControl.length > 0) {
      paymentChangeObj['taxesAndInsuranceWitholdBeginDate'] = {date:this.utilService.convertDateToMillisec(this.fromEMBRequiredControl)};
    }

    if (this.toEMBRequiredControl != null && this.toEMBRequiredControl.length > 0) {
      paymentChangeObj['taxesAndInsuranceWitholdEndDate'] = {date:this.utilService.convertDateToMillisec(this.toEMBRequiredControl)};
    }


    transactionWrapper.parameters[0] = paymentChangeObj;
    console.log('Payment Change Obj New:', paymentChangeObj);
    this.apiService.getQueryPaymentChange(transactionWrapper)
      .subscribe(
        (data: any) => {
            
          this.displayLoanNumber = this.loanNumber;
          this.displayEffDate = this.utilService.convertMillisecToDate(this.effDate);
          this.displayPaymentPlan = this.paymentPlan;

          if (data.validationContext.errorMessages) {
            this.errorMessage = data.validationContext.errorMessages;
          } else {
            this.successMess = true;
            this.displayWarningMsg = data.validationContext.warningMessages;
          }
          console.log('returned msg:' + data);
          this.cdr.detectChanges();
        },
        error => {
          console.log(error);
          if (error.includes('ErrorCode:500,Something bad happened; please try again later.')) {
            this.errorMessage.push(Constants.PLS_RE_SUBMIT);
          } else if (error.includes('executePaymentChangeUserTransaction: 500')) {
            this.errorMessage.push(Constants.PLS_RE_SUBMIT);
          } else if (error.length > 0) {
            this.errorMessage = error;
          } else {
            this.errorService.announceError(error);
          }
          this.cdr.detectChanges();
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        console.log('Error message *** ' + message);
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.paymentChangeComponent();}
  }

}
